import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m20.722 19.559-4.71-4.711c1.019-1.248 1.581-2.82 1.581-4.536A7.31 7.31 0 0 0 10.281 3C6.242 3 3 6.274 3 10.313s3.274 7.312 7.28 7.312a7.27 7.27 0 0 0 4.536-1.583l4.711 4.71a.97.97 0 0 0 .63.248.84.84 0 0 0 .596-.247.82.82 0 0 0-.03-1.194M4.688 10.312a5.63 5.63 0 0 1 5.625-5.624 5.63 5.63 0 0 1 5.624 5.625 5.63 5.63 0 0 1-5.624 5.624 5.63 5.63 0 0 1-5.625-5.624"
    }, null, -1)
  ]))]))
}
export default { render: render }